import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import Typography from "@mui/material/Typography"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Grid } from "@mui/material"
import theme_colors from "../../../configs/theme_colors.json"

function GridRow(props) {
  const { facility_type, facility_list } = props

  if (!facility_list) {
    return null
  }

  return (
    <Grid container key={facility_type}>
      <Grid
        item
        xs={3}
        style={{
          width: "100%",
          paddingTop: 4,
          paddingRight: 20,
          textAlign: "right",
          color: theme_colors.ndoh_green,
        }}
      >
        <Typography variant="h6" fontWeight={"bold"}>
          {facility_list.length ? facility_list.length : "0"}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Accordion style={{ marginBottom: 10 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              minHeight: 32,
              "& .MuiAccordionSummary-content": {
                margin: 0,
              },
            }}
          >
            <Typography component="span">{facility_type}</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              maxHeight: 100,
              overflowY: "auto",
            }}
          >
            {facility_list.map((name, index) => (
              <Typography
                key={name}
                variant="body2"
                sx={{
                  borderBottom:
                    index < facility_list.length - 1
                      ? "1px solid #ccc"
                      : "none",
                  paddingY: 0.5,
                }}
              >
                {name}
              </Typography>
            ))}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  )
}

export default function FacilitiesList(props) {
  const { hospitals_in_current_study_area, study_area } = props

  return (
    <div
      style={{
        height: study_area === "districts" ? 280 : 240,
        overflow: "auto",
      }}
    >
      <GridRow
        facility_type={"District Hospitals"}
        facility_list={hospitals_in_current_study_area.district}
      />
      <GridRow
        facility_type={"Regional Hospitals"}
        facility_list={hospitals_in_current_study_area.regional}
      />
      <GridRow
        facility_type={"CHCs"}
        facility_list={hospitals_in_current_study_area.chc}
      />
      <GridRow
        facility_type={"Private Acute Hospitals"}
        facility_list={hospitals_in_current_study_area.private_acute}
      />
      <GridRow
        facility_type={"Clinics"}
        facility_list={hospitals_in_current_study_area.clinic}
      />
      <GridRow
        facility_type={"GPs"}
        facility_list={hospitals_in_current_study_area.gp}
      />
      {study_area === "districts" ? (
        <GridRow
          facility_type={"CUPs"}
          facility_list={hospitals_in_current_study_area.cups}
        />
      ) : null}
    </div>
  )
}
